import React from 'react';
import { useNavigate } from 'react-router-dom';
import cl from 'classnames';
import { usePageParams } from 'src/hooks';
import { Select, Link } from 'src/components/general';
import styles from './pageSwitcherStyle.module.scss';

type PageSwitcherProps = {
  className?: string;
  selectClassName?: string;
};

export const PageSwitcher = ({
  className,
  selectClassName,
}: PageSwitcherProps) => {
  const navigate = useNavigate();
  const { pageList } = usePageParams();

  if (!pageList) {
    return null;
  }

  return (
    <div className={cl(styles.container, className)}>
      <div className={styles.buttons}>
        {pageList.list.map(({ id, label }) => (
          <Link
            key={`psBtn-${id}`}
            className={cl(
              styles.button,
              id === pageList.currentId && styles.current,
            )}
            src={id !== pageList.currentId ? `${pageList.rootUrl}/${id}` : null}
          >
            <div className={styles.label}>{label}</div>
          </Link>
        ))}
      </div>
      <div className={styles.mobileGroup}>
        <Select
          value={pageList.currentId}
          items={pageList.list.map(({ id, label }) => ({ value: id, label }))}
          selectItem={(id) => {
            if (id === pageList.currentId) {
              return;
            }
            navigate(`${pageList.rootUrl}/${id}`);
          }}
          design="switcherBorder"
          className={selectClassName}
        />
      </div>
    </div>
  );
};

export default PageSwitcher;
